<template>

  <div>
    <base-header type="gray-100" class="pb-6 pb-8 pt-5 pt-md-5">
        </base-header>

     <template v-if="loading">
        <div class="m-2">
        <skeleton altura="400px" :velocidade="2.2" :atraso="0.2" :itens="1" classItem="mb-2"></skeleton>
        </div>
    </template>
    
    <div class="container-fluid mt--7" v-if="!loading">
        <div class="row">
            <div class="col">
                <div class="card shadow p-4">
                    <div class="card-header border-0">
                    <div class="row align-items-center">
                        <div class="header">
                            <h3 class="mb-0">
                                Agenda Protética
                            </h3>

                            <div class="nav-agenda">
                                <span v-on:click="navWeeks('prev')">
                                    <i class="fas fa-arrow-left"></i>
                                </span>

                                 <span v-on:click="navWeeks('next')">
                                    <i class="fas fa-arrow-right"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                    </div>

                    <div class="agenda">  
                        <div class="agenda__dia" v-for="(item, i) in calculedWeek" :key="i">
                             <div class="agenda__head" :class="{ 'agenda__head--today': isToday(item.global) }">
                                <div class="agenda__day">
                                    {{ item.dayMonth }}
                                </div>
                                <div class="agenda__more_day">
                                    <div class="agenda__month">
                                        {{ item.month }}
                                    </div>

                                    <div class="agenda__dayweek">
                                        {{ item.dayWeek }}
                                    </div>
                                </div>
                            </div>
                            <div class="agenda__body" v-for="(hour, i) in getDayHours()" :key="i">
                                <div class="agenda__time">
                                    <span>{{ fHour(hour) }}</span>
                                    <base-button v-if="user.tipo == 'lab'" :to="'/agenda-protetica/job/' + item.global + '/' + fHour(hour)" type="secondary" icon="fas fa-plus" size="sm">
                                    </base-button>
                                </div>    

                                 <div class="agenda__job" v-for="(job, i) in getJobs(item.global, fHour(hour))" :key="i">
                                    <div class="agenda__box" :style="boxColor(job.status.valor)" @click="goToJobForm(job.id, item.global, fHour(hour))">
                                        <div class="agenda__author">
                                            <span>Laboratório:</span>
                                            <span>{{ job.laboratorio.nomeFantasia }}</span>
                                        </div>
                                        <div class="agenda__subauthor">
                                            <span>Protético:</span>
                                            <span>{{ job.protetico.nomeCompleto }}</span>
                                        </div>
                                        <div class="agenda__subauthor" ng-if="job.paciente">
                                            <span>Paciente:</span>
                                            <span>{{ job.paciente }}</span>
                                        </div>
                                        <div class="agenda__status">
                                            <span :style="labelColor(job.status.valor)">{{ job.status.nome }}</span>
                                        </div>
                                    </div>
                                </div>   
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
                    
    
  </div>
</template>

<script>
import moment from 'moment';
import agenda from '@/cflow/agendaProtetica.js'
import router from '@/router'
 import storage from 'storage';
export default {
    methods: {
        getDaysInMonth: function(month, year) {
            var date = new Date(year, month, 1);
            var days = [];
            while (date.getMonth() === month) {
                days.push(new Date(date));
                date.setDate(date.getDate() + 1);
            }
      
            return days;
        },
        getMountDays: function() {
            var days = [];
            for(var i = 1; i <= 31; i++) {
                days.push(i);
            }
         
            return days;
        },
        isToday: function(date) {
            let today = moment().locale('pt-br').format('YYYY-MM-DD');

            if(today == date) return true;
            return false;
        },
        navWeeks(direction) {
            if(typeof this.week === 'undefined') this.week = 0;
            if(direction == 'prev') this.week--;
            if(direction == 'next') this.week++;
            this.calculedWeek = this.getCalculedWeek();
        },
        getCalculedWeek: function() {

            let date = moment();

            if(this.week > 0) {
                date = moment(date).locale('pt-br').add(this.week, 'weeks');
            }

            if(this.week < 0) {
                date = moment(date).locale('pt-br').subtract(this.week * -1, 'weeks');
            }

            let dayOfWeek = date.day();
            let weekDays = [];

            for(var i1 = 0; i1 < dayOfWeek; i1++) {
                weekDays.push(i1);
            }

            for(var i2 = dayOfWeek; i2 <= 6; i2++) {
                weekDays.push(i2);
                
            }

            let firstDateOfWeek = moment(date).subtract(dayOfWeek, 'days');
            let daysOfWeek = [];
            let day;
            let obj;

            for(var i3 = 0; i3 <= 6; i3++) {
                day = moment(firstDateOfWeek).locale('pt-br').add(i3, 'days')
                obj = {
                    year: day.format('YYYY'),
                    month: day.format('MMMM'),
                    dayMonth: day.format('DD'),
                    dayWeek: day.format('dddd'),
                    global: moment(day).format('YYYY-MM-DD')
                }
                daysOfWeek.push(obj);
            }

            //let firstDayMonth = moment(date).startOf('month').format('YYYY-MM-DD');
            //let lastDayMonth = moment(date).endOf('month').format('YYYY-MM-DD');

            this.getAgenda(daysOfWeek[0].global, daysOfWeek[6].global);


            return daysOfWeek;
        },
        getDayHours: function() {
            let hours = [];
            for(var i = 7; i <= 18; i++) {
                hours.push(i);
            }
            return hours;
        },
        fHour(hour) {
            return hour.toString().padStart(2, '0') + ':00';
        },
        getAgenda(from, to) {

            const _this = this;
            _this.loading = true;

            agenda.listar(from, to).then(res => {
                _this.loading = false;
                this.jobs = res.filter(item => item.status.valor !== 'cancelado');
            }).catch((error) => {
                console.err('ERROR', error)
            });
        },
        getJobs(data, hora) {
            const _this = this;
            const jobs = _this.jobs;
            let itens = [];

            jobs.forEach(item => {
                if(item.data == data && this.formatarHora(item.hora) == hora) {
                    itens.push(item);
                }
            })

            return itens;

        },
        goToJobForm(id, data, hora) {
            router.push('/agenda-protetica/job/' + data + '/' + hora + '/' + id);
        },
         boxColor(key) {
            return {
                'border-color': this.statusAgendaProtetico(key)
            };
        },
        labelColor(key) {
            return {
                'color': this.statusAgendaProtetico(key)
            };
        },
    },
    data() {
        return {
            loading: false,
            calculedWeek: [],
            week: 0,
            jobs: [],
            user: {}
        }
    },
     mounted(){
      //this.initLoad(0);
      this.calculedWeek = this.getCalculedWeek();
      this.user = storage.get("user");
    },
    computed: {
   
  }
  };
</script>
<style>

.header {
    width: 100%;
    display: flex;
    justify-content: space-between;
}

.nav-agenda {
    font-size: 30px;
}

.nav-agenda span {
    cursor: pointer;
}

.nav-agenda span:first-child {
    margin-right: 20px;
}

.agenda {
    display: flex;
    width: 100%;
    flex-flow: row wrap;
}

.agenda__dia {
    margin: 4px;
    flex: 0 1 calc(14.25% - 8px);
}

.agenda__head {
    display: flex;
    justify-content: center;
    align-items: center;
}

.agenda__head--today {
   background: #eee;
   border: 1px solid #ccc;
   border-bottom: none;
}

.agenda__day {
    font-weight: 700;
    font-size: 40px;
}

.agenda__more_day {
    padding-left: 10px;
}

.agenda__month {
    font-size: 12px
}

.agenda__dayweek {
    font-size: 12px;
    text-transform: uppercase;
}

.agenda__body {
    border: 1px solid #ccc;
    border-bottom: none;
    min-height: 80px;
    padding: 5px;
}

.agenda__body:last-child {
    border-bottom: 1px solid #ccc;
}

.agenda__time {
    display: flex;
    justify-content: space-between;
}

.agenda__box {
    border-left: 4px solid transparent;
    padding: 10px;
    margin: 10px 0;
    cursor: pointer;
}

.agenda__subauthor {
    padding: 5px 0;
}

.agenda__author span, .agenda__subauthor span {
    display: block;
    width: 100%;
}

.agenda__author span:first-child, .agenda__subauthor span:first-child {
    text-transform: uppercase;
    font-size: 10px;
}

.agenda__author span:last-child, .agenda__subauthor span:last-child {
    font-size: 15px;
}

.agenda__status {
    font-weight: 700;
    font-size: 12px;
    text-transform: uppercase;
}

</style>
